import { useAuth } from "@clerk/clerk-react";
import useSWR from "swr";
import { TUser } from "../types/Users";
import { apiDelete, apiPatch, apiPost, fetcher } from "../utils/axios";

const useUsers = () => {
  const { getToken } = useAuth();

  const { data, error, mutate } = useSWR(`/users`, async (url) => {
    const token = await getToken();
    return fetcher(url, token);
  });

  const inviteUser = async (email: string, send_device_notifications?: boolean, location_based_alerts?: boolean, location_alert_selections?: string[]) => {
    const token = await getToken();
    const payload = { 
      email, 
      ...(send_device_notifications !== undefined && { send_device_notifications }),
      ...(location_based_alerts !== undefined && { location_based_alerts }),
      ...(location_alert_selections && { location_alert_selections })
    };
    return apiPost(`/users`, payload, token);
  };

  const updateUser = async (id: string, obj: Partial<TUser>) => {
    const token = await getToken();

    // console.log("Updating user with ID:", id, "and data:", obj);
    return apiPatch(`/users/${id}`, obj, token);
  };

  const deleteUser = async (id: string) => {
    const token = await getToken();
    return apiDelete(`/users/${id}`, token);
  };

  return {
    users: (data as TUser[]) || [],
    isLoading: !error && !data,
    isError: error,
    inviteUser,
    mutate,
    deleteUser,
    updateUser,
  };
};

const useUser = (id: string) => {
  const { getToken } = useAuth();

  const { data, error } = useSWR(`/users/${id}`, async (url) => {
    const token = await getToken();
    return fetcher(url, token);
  });

  return {
    user: data as TUser | undefined,
    isLoading: !error && !data,
    isError: error,
  };
};

export { useUser, useUsers };
